/// <reference path="../app.ts" />
module Cfnc {
    "use strict";

    interface ICfncIFrame extends angular.IDirective {
    }

    interface ICfncIFrameScope extends angular.IScope {
        dataSrc: string;
        onReceivedMessage: () => void;
    }

    interface ICfncIFrameAttributes extends angular.IAttributes {
        onReceivedMessage
    }

    CfncIFrame.$inject = ["$sce", "$window"];
    function CfncIFrame($sce: ng.ISCEService, $window: ng.IWindowService): ICfncIFrame {
        return {
            restrict: "E",
            link: link,
            template: "<iframe></iframe>",
            replace: true,
            scope: {
                onReceivedMessage: "="
            }
        }

        function link(scope: ICfncIFrameScope, element: angular.IAugmentedJQuery, attrs: ICfncIFrameAttributes) {
            if (attrs.onReceivedMessage) {
                $window.addEventListener("message", (e: MessageEvent) => {
                    scope.onReceivedMessage.call(scope.$parent, e.data);

                });
            }
        }
    }

    angular.module("app").directive("cfncIframe", CfncIFrame);
}